import { MailboxesStoreStateType } from '../../Types/MailboxesStoreTypes';
import { MailboxesStoreActionsType } from '../../Types/MailboxesReducerTypes';

export default function MailboxesReducer(
	state: MailboxesStoreStateType,
	action: MailboxesStoreActionsType,
): MailboxesStoreStateType {
	switch (action.type) {
		case 'updateActiveMailItem':
			return {
				...state,
				preItemUpdate: action.preItemUpdate,
				mailItemRequiresTopUp: action.mailItemRequiresTopUp,
				mailItemOnHold: action.mailItemOnHold,
			};
		case 'updateMailboxInfo':
			return {
				...state,
				mailBoxInfo: action.payload,
			};
		case 'updateMailNoteData':
			return {
				...state,
				mailNote: action.payload,
			};
		case 'updateCustomFolderData':
			return {
				...state,
				activeCustomFolderData: action.payload,
			};
		case 'updateActionConfirmationData':
			return {
				...state,
				confirmActionData: action.payload,
			};
		case 'updateForwardItemsData':
			return {
				...state,
				forwardItemsData: action.payload,
			};
		case 'updateParentFolderId':
			return {
				...state,
				parentFolderId: action.folderId,
			};
		case 'setCustomFolderUpdating':
			return {
				...state, // TODO: rename 'mailFolderModificationActive'
				mailFolderModificationActive: action.state,
			};
		case 'setItemMoving':
			return {
				...state,
				itemMoving: action.state,
			};
		case 'toggleMailboxesFilterModal':
			return {
				...state,
				showFilterModal: action.state,
			};
		case 'toggleCustomFolderModal':
			return {
				...state,
				createCustomFolderOpen: action.state,
			};
		case 'toggleDeleteCustomFolderModal':
			return {
				...state,
				deleteCustomFolderOpen: action.state,
			};
		default:
			return state;
	}
}
